/* Firkin Jelly - acceleration du chargement (videos du bandeau + photos Flow Color Collection).
   Fichier autonome : retirer la ligne fj-perf.js dans layout/theme.liquid pour desactiver. */
(function () {
  if (window.__fjPerf) return;
  window.__fjPerf = true;

  var conn = navigator.connection;
  var saveData = !!(conn && (conn.saveData || /2g/.test(conn.effectiveType || '')));
  var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1); };

  /* ---------- 1. Videos du bandeau (Marquee defilee) ---------- */
  /* Toujours la version 480p (vignettes ~240 px : deja nette sur Retina, 2x plus legere que 720p),
     lancement des le premier affichage au lieu d'attendre la fin du chargement de la page,
     et prechargement des videos voisines qui arrivent dans le bandeau. */
  /* full = video a l'ecran (telechargee en entier pour la lecture) ;
     sinon on ne charge que le debut du fichier, pour que la video demarre instantanement
     quand elle arrive, sans saturer la connexion avec plusieurs gros telechargements en parallele */
  function loadVideo(v, full) {
    if (full && v.preload !== 'auto') v.preload = 'auto';
    if (v.getAttribute('src')) return;
    var src = v.dataset.mqdSrc || v.dataset.mqdSrcHd;
    if (!src) return;
    if (!full) v.preload = 'metadata';
    v.src = src;
  }

  function playVideo(v) {
    loadVideo(v, true);
    v.muted = true;
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function initMarquee(section) {
    if (section.dataset.fjPerf === 'true') return;
    section.dataset.fjPerf = 'true';
    var list = Array.prototype.slice.call(section.querySelectorAll('video[data-mqd-src]'));
    if (!list.length) return;
    if (!('IntersectionObserver' in window)) return;

    var show = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          playVideo(v);
          var i = list.indexOf(v);
          [i + 1, i + 2].forEach(function (k) { if (list[k]) loadVideo(list[k], false); });
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '50px 0px' });

    var near = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { loadVideo(e.target, false); near.unobserve(e.target); }
      });
    }, { rootMargin: '600px 0px' });

    list.forEach(function (v) { show.observe(v); near.observe(v); });
  }

  function initMarquees(root) {
    if (saveData || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    (root || document).querySelectorAll('[data-wb-mqd]').forEach(initMarquee);
  }

  /* ---------- 2. Photos Flow Color Collection ---------- */
  /* Les photos des cartes ne se chargeaient qu'au moment ou elles apparaissaient (defilement ou
     changement de couleur). On precharge les premieres cartes des que la section approche de l'ecran,
     puis toutes les autres des que la cliente touche ou survole la section.
     Rien n'est telecharge si la cliente ne descend pas jusqu'a la section (page legere). */
  function warmFlow(section, all) {
    if (section.dataset.fjWarm === 'all' || (!all && section.dataset.fjWarm === 'shown')) return;
    section.dataset.fjWarm = all ? 'all' : 'shown';
    var n = 0;
    section.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (!all && (n >= 8 || img.closest('[hidden]'))) return;
      n++;
      img.loading = 'eager';
    });
  }

  function initFlow(section) {
    if (section.dataset.fjWarmSetup === 'true') return;
    section.dataset.fjWarmSetup = 'true';
    var go = function () { warmFlow(section, false); };
    var goAll = function () { warmFlow(section, true); };
    section.addEventListener('pointerdown', goAll, { once: true, passive: true });
    section.addEventListener('touchstart', goAll, { once: true, passive: true });
    section.addEventListener('pointerenter', goAll, { once: true, passive: true });
    section.addEventListener('wheel', goAll, { once: true, passive: true });
    section.querySelectorAll('[data-cat-btn]').forEach(function (b) {
      b.addEventListener('focus', goAll, { once: true });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); }
      }, { rootMargin: '1200px 0px' });
      io.observe(section);
    } else {
      go();
    }
  }

  function initFlows(root) {
    (root || document).querySelectorAll('.wb-flow-coll__track').forEach(function (track) {
      var section = track.closest('.shopify-section') || track.parentElement;
      if (section) initFlow(section);
    });
  }

  /* ---------- Demarrage ---------- */
  /* Les videos attendent que la grande image du haut de page soit affichee (max 2,5 s),
     pour qu'elles ne lui volent pas la connexion : la page apparait d'abord, les videos juste apres */
  function afterHero(cb) {
    var done = false;
    var go = function () { if (done) return; done = true; idle(cb, { timeout: 300 }); };
    var hero = Array.prototype.filter.call(document.querySelectorAll('img[fetchpriority="high"]'), function (img) {
      var r = img.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.top < window.innerHeight;
    });
    var pending = hero.filter(function (img) { return !img.complete; });
    if (!pending.length) { go(); return; }
    var left = pending.length;
    pending.forEach(function (img) {
      var one = function () { if (--left <= 0) go(); };
      img.addEventListener('load', one, { once: true });
      img.addEventListener('error', one, { once: true });
    });
    setTimeout(go, 2500);
  }

  function boot() {
    afterHero(function () { initMarquees(document); });
    initFlows(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initMarquees(e.target);
    initFlows(e.target);
  });
})();
